<template lang="pug">
  .content-wrapper
    //- 选择优惠券弹框 
    choose-coupon(v-if="show_coupon", v-model="show_coupon", tips="温馨提示：活动报名奖励优惠券仅支持库存为无限制优惠券" :array="store_coupons", :params="'2'" @resolve="getCouponList")
    //- 人群限制模态框
    slide-out-modal(v-if="slideVisible" @input="showAddModel")
      choose-customer(:id="info.user_limit" @success="seleckType")
    //- 海报预览弹框
    //- 海报预览
    slide-out-modal(v-if="posterVisible" @input="onPreviewPosters")
      view-poster(:poster_info="poster_info")
    //- 表单
    .form-wrapper
      .field-group
        .field.is-horizontal
          label.label.must 名称
          custom-input(v-model.trim="info.title"
            placeholder="店庆专属活动"
            maxlength="10"
            :validator="$v.info.title",
            error-info="请填写活动名称")
        .field.is-horizontal
          label.label.must 活动时间
          date-picker(type="range", 
            v-model="info.time",
            style="width: 260px;",
            :validator="$v.info.time",
            error-info="请选择活动时间")
        .field.is-horizontal
          label.label.must 活动说明
          div(style="flex-grow: 1;")
            custom-textarea(v-model="info.description",
              placeholder="请输入活动说明（30字以内）",
              maxlength="30")
            .desc-box
              //- .desc-text 活动说明的文字，会在活动海报中展示出来
              .textbox-count {{info.description.length}}/30
        .field.is-horizontal
          label.label.must 活动内容
          div(style="flex-grow: 1;")
            custom-textarea(v-model="info.content",
              placeholder="请输入活动内容（100字以内）",
              maxlength="100",
              :validator="$v.info.content",
              error-info="请输入活动内容")
            .desc-box
              .textbox-count {{info.content.length}}/100
            .control.image-wrapper
              .upload-pic(v-for="(cell, index) in info.content_imgs")
                upload-img-model(v-model="info.content_imgs[index]",
                  @other="deleteImage",
                  img-type="item",
                  :has-second-action="true",)
              .upload-pic(v-if="info.content_imgs.length < 5")
                upload-img-model(v-model="info.content_imgs[info.content_imgs.length]",
                  img-type="item",
                  :has-second-action="false",)
        .field.is-horizontal
          label.label.must 海报上传
          .control.image-wrapper
            .upload-poster
              upload-img-model(v-model="info.poster_img",
                :isDisabled="true",
                img-type="item",
                :has-second-action="false",
                lookPicText="预览海报",
                @previewPosters="onPreviewPosters(info)",)
        .field.is-horizontal
          label.label.must 轮播图配置
          .control.image-wrapper
            .upload-poster
              upload-img-model(v-model="info.slider_img",
                img-type="item",
                :has-second-action="false",)
        .field.is-horizontal
          label.label
          ul
            li.font-des 1、建议上传尺寸为750x340的jpg/png格式文件，文件不能超过1M；
            li.font-des 2、轮播图默认跳转为该活动页；
            li.font-des 3、活动上架后，已配置的轮播图将可以直接上架；
        .field.is-horizontal
          label.label 优惠券配置
          a.button.primary(@click="selectCoupon") 选择优惠券
          span.font-des(style="margin-left: 10px;") 活动上架后，将支持优惠券直接上架；
        .field.long.is-horizontal(v-if="info.coupons.length > 0")
          label.label
          .box
            ul.clearfix.coupon
              li.fl.w-80 类型
              li.fl.w-110 名称
              li.fl.w-80 金额
              li.fl 使用条件
              li.fl.w-180 有效时间
              li.fl.operation 操作
            ul.clearfix.coupon-list(v-for="(item, index) in info.coupons")
              li.fl.w-80(v-if="item.coupon_type == 1") 代金券
              li.fl.w-80(v-if="item.coupon_type == 2") 兑换券
              li.fl.w-80(v-if="item.coupon_type == 3") 满减券
              li.fl.w-80(v-if="item.coupon_type == 4") 折扣券
              li.fl.w-110(:title="item.coupon_name ? item.coupon_name : item.item_name") {{item.coupon_name ? item.coupon_name : item.item_name}}
              li.fl.w-80(v-if="item.coupon_type != 4") {{item.discount_amount/100}}元
              li.fl.w-80(v-if="item.coupon_type == 4") {{item.discount_amount/100}}折
              li.fl {{item.condition_value == 0 ? '无限制' : '满'+ item.condition_value/100 + '元可用'}}
              li.fl.w-180(v-if="item.effective_type == 3") 无限制
              li.fl.w-180(v-if="item.effective_type == 2") 自领取{{item.effective_days}}
              li.fl.w-180(v-if="item.effective_type == 1") {{item.effective_days}}
              li.fl.operation
                a.operation-link(@click="deleteCoupon(index)") 删除
        .field.long.is-horizontal
          label.label.must 活动门店
          .box
            ul.clearfix.coupon
              li.fl.w-30(v-html="'<pre> </pre>'")
              li.fl.w-180 门店名称
              li.fl 联系电话
              li.fl.w-350 地址
            ul.clearfix.coupon-list(v-for="(item, index) in info.store")
              li.fl.w-30 
                .checkbox
                  input(type="checkbox", v-model="store_list", :value="item")
                  label
              li.fl.w-180 {{item.store_name}}
              li.fl {{item.business_phone}}
              li.fl.w-350(:title="`${item.province_name + item.city_name}市${item.district_name}区${item.address}`") {{`${item.province_name + item.city_name}市${item.district_name}区${item.address}`}}
        .field.is-horizontal
          label.label.must 用户限制
          div.type-item
            .radio
              input(type="radio", v-model="btn_limit", id="limit-0", :value="0")
              label.sepcific-setting(for="limit-0") 无限制
          div.type-item
            .radio
              input(type="radio", v-model="btn_limit", id="limit-1", :value="1")
              label.sepcific-setting(for="limit-1") 人群限制
          a.button(@click="showAddModel", :class="btn_limit !== 0 ? 'primary' : 'not-allow'") 选择人群
          div(v-if="info.user_limit != 0", style="margin-left: 10px; font-size: 13px;") 
            span(v-if="info.user_limit == 1") 小程序已下单客户
            span(v-if="info.user_limit == 2") 小程序未下单客户
        .field.is-horizontal
          label.label.must 报名方式
          .checkbox.disabled
            input(type="checkbox", v-model="register_type", value="1", disabled)
            label 车牌
          .checkbox
            input(type="checkbox", v-model="register_type", id="auto-info", value="2")
            label(for="auto-info") 车辆信息
          .checkbox
            input(type="checkbox", v-model="register_type", id="distance", value="3")
            label(for="distance") 行驶里程
        //- .field.is-horizontal
        //-   label.label.must 小程序报名用户
        //-   .checkbox
        //-     input(type="checkbox", v-model="info.sign_up_switch", value="1",)
        //-     label(for="sign_up_switch") 小程序页面报名成功用户展示
    //- 底部按钮
    .btn-wrapper
      .button-group
        a.button.large(v-if="!is_edit", @click="goBack") 返回上一步
        a.button.primary.large(@click="next") 下一步
</template>

<script>
import Api from '@/mixins/modules/Content'
import CustomInput from '@/components/generics/form/CustomInput'
import DatePicker from '@/components/generics/form/DatePicker'
import CustomTextarea from '@/components/generics/form/CustomTextarea'
import UploadPic from '@/components/generics/form/UploadPic'
import uploadImgModel from '@/components/content/modal/uploadImgModel'
import SlideOutModal from '@/components/generics/SlideOutModal'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import ChooseCoupon from '@/components/marketing/modal/ChooseCoupon'
import ChooseCustomer from '@/components/content/modal/ChooseCustomer'
import ViewPoster from '@/components/content/modal/ViewPoster'
import utils from '@/mixins/utilities/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'ContentTemplateTwo',
  mixins: [Api, validationMixin, utils],
  components: {
    CustomInput,
    DatePicker,
    CustomTextarea,
    UploadPic,
    uploadImgModel,
    ChooseCoupon,
    SlideOutModal,
    ChooseCustomer,
    ViewPoster,
  },
  props: {
    is_show: {
      type: Boolean, // 当前组件是否为显示状态（第2步）
      default: false,
    },
    is_save_data: {
      type: Boolean, // 是否保留数据之前数据,不重新请求接口（用于第3步向第2步返回）
      default: false,
    },
    template_id: {
      type: [Number, String], // 模板id（新建时传）
    },
    activity_id: {
      type: [Number, String], // 活动id（编辑时传）
    },
    is_edit: {
      type: Boolean, // 是否为编辑状态，直接跳转第二步
    },
  },
  computed: {
    ...mapGetters({
      currentStore: 'currentStore',
    }),
  },
  data () {
    return {
      info: {
        title: '', // 活动名称
        time: '', // 活动时间
        start_time: '', // 活动开始时间
        end_time: '', // 活动结束时间
        description: '', // 活动介绍
        content: '', // 活动内容
        content_imgs: [], // 活动内容图片
        cover_img: '', // 活动封面图
        poster_img: '', // 海报
        slider_img: '', // 轮播图
        coupons: [], // 优惠券
        store: [], // 门店信息
        user_limit: 0, // 人群限制：0-无限制 1-小程序下单客户 2-小程序未下单客户
        register_type: '1,2', // 报名方式 1车牌 2车型 3公里数 多个用逗号分隔(例: 1,2)
        sign_up_switch: 0, // 0关闭 1开启
      },
      store_coupons: [], // 手动选择（添加）的门店优惠券
      btn_limit: 0, // 选择人群按钮控制 0: 无限制，1: 选择人群
      register_type: [1, 2], // 报名方式 1车牌 2车型 3公里数
      // 控制选择优惠券弹框显隐
      show_coupon: false,
      slideVisible: false, // 用户限制弹框显示状态
      // 活动门店
      store_list: [],
      posterVisible: false, // 控制海报预览模态框
    }
  },
  validations: {
    info: {
      title: {
        required,
      },
      time: {
        required,
      },
      description: {
        required,
      },
    },
  },
  mounted () {
    console.log(this.info.sign_up_switch, 'here')
  },
  methods: {
    // 海报预览模态框(参数为info)
    async onPreviewPosters (item) {
      // 关闭组件不请求接口
      if (!this.posterVisible) {
        let posterInfo = JSON.parse(JSON.stringify(item))
        posterInfo.start_time = this.changeDate(item.start_time).trim().replace(/-/g, '.')
        posterInfo.end_time = this.changeDate(item.end_time).trim().replace(/-/g, '.')
        posterInfo.store_name = this.currentStore.store_name
        posterInfo.address = this.currentStore.address
        this.poster_info = posterInfo
        if (item.activity_id) {
          this.poster_info.qr_code = await this.getActivityStoreQrCode(item.activity_id)
        }
      }
      this.posterVisible = !this.posterVisible
    },
    // 获取活动二维码（模板活动海报预览用）传活动id
    async getActivityStoreQrCode (id) {
      try {
        const { response, result } = await this.GetActivityStoreQrCodeApi({
          id,
        })
        if (response.status === 200 && result.code === 0) {
          return result.data.image
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取中央活动库详情数据失败',
            content: `${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取活动二维码失败',
          content: `错误：${err}`,
        })
      }
    },
    /**
     * 时间戳转年月日+时分秒
     * @val  时间戳
     */
    changeDate (val) {
      if (!val) {
        return ''
      }
      let date = new Date(val * 1000)
      let Y = date.getFullYear() + '-'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      let D = this.judgeTime(date.getDate()) + ' '
      return Y + M + D
    },

    /**
     * 时 分 格式化
     * @t  时分
     */
    judgeTime (t) {
      if (t < 10) {
        return '0' + t
      } else {
        return t
      }
    },
    // 返回列表页（编辑）或上一步（新建）
    goBack () {
      if (this.is_edit) {
        this.$router.push({
          name: 'contentList',
        })
      } else {
        this.$emit('prevstep', 1, false)
      }
    },

    // 删除图片（活动内容）
    deleteImage (url) {
      const index = this.info.content_imgs.findIndex(val => val === url)
      this.info.content_imgs.splice(index, 1)
    },

    // 控制选择优惠券弹框显隐
    selectCoupon () {
      this.show_coupon = !this.show_coupon
    },

    /**
     * 选择添加优惠券
     * @list {Array} 选择的优惠券列表
     */
    getCouponList (list) {
      this.store_coupons = JSON.parse(JSON.stringify(list))
      // Boss带过来的优惠券
      let bossArr = []
      for (let i = 0; i < this.info.coupons.length; i++) {
        if (this.info.coupons[i].id || this.info.coupons[i].object_extra_id) {
          bossArr.push(this.info.coupons[i])
        }
      }
      this.info.coupons = [...bossArr, ...this.store_coupons]
    },

    // 删除优惠券配置项
    deleteCoupon (index) {
      const id = this.info.coupons[index].coupon_id || this.info.coupons[index].item_id
      this.info.coupons.splice(index, 1)
      // 如果id有值说明是门店优惠券
      if (id) {
        for (let i = 0; i < this.store_coupons.length; i++) {
          if (this.store_coupons[i].coupon_id === id) {
            this.store_coupons.splice(i, 1)
            break
          }
        }
      }
    },

    // 用户限制预览模态框显隐
    showAddModel () {
      if (this.btn_limit === 0) return
      this.slideVisible = !this.slideVisible
    },

    /**
     * 模态框回调的数据 指定用户
     * @id {Number} 指定用户id 1 下单 2 未下单
     */
    async seleckType (id) {
      this.showAddModel()
      this.info.user_limit = id
    },

    // 下一步
    next (step) {
      // 数据校验
      this.$v.$touch()
      if (this.$v.$error) return false
      if (this.info.time) {
        // 2019-10-15 至 2019-10-17
        let arr = this.info.time.split(' 至 ')
        arr[0] = arr[0].split('-').join('/') + ' 00:00:00'
        arr[1] = arr[1].split('-').join('/') + ' 23:59:59'
        this.info.start_time = new Date(arr[0]) / 1000
        this.info.end_time = new Date(arr[1]) / 1000
      }
      let today = new Date() / 1000
      if (this.info.end_time < today) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '活动结束时间不能小于今天',
        })
        return
      }
      if (this.info.poster_img === '') {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '请上传海报',
        })
        return
      }
      if (this.info.content === '' && this.info.content_imgs.length === 0) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '请填写活动内容或上传内容图片',
        })
        return
      }
      if (this.info.slider_img === '') {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '请上传轮播图',
        })
        return
      }
      // 判断优惠券数量最大5张
      if (this.info.coupons.length > 5) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '最多可以选择5张优惠券',
        })
        return
      }
      if (this.store_list.length <= 0) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '请选择活动门店',
        })
        return
      }
      if (this.btn_limit !== 0 && Number(this.info.user_limit) === 0) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '请选择限制人群',
        })
        return
      }
      // 处理store_list参数，门店id拼接字符串
      let store = ''
      for (let i = 0; i < this.store_list.length; i++) {
        store += `${this.store_list[i].store_id},`
      }
      this.info.store_list = store
      // 处理优惠券参数
      let couponsList = []
      // 如果是编辑状态，优惠券处理参数
      if (this.is_edit) {
        for (let i = 0; i < this.info.coupons.length; i++) {
          couponsList.push({
            object_id: this.info.coupons[i].item_id ? this.info.coupons[i].item_id : (this.info.coupons[i].coupon_id ? this.info.coupons[i].coupon_id : 0),
            object_extra_id: this.info.coupons[i].object_extra_id ? this.info.coupons[i].object_extra_id : 0,
          })
        }
      } else {
        // 如果是新增状态，优惠券处理参数
        for (let i = 0; i < this.info.coupons.length; i++) {
          couponsList.push({
            object_id: this.info.coupons[i].coupon_id ? this.info.coupons[i].coupon_id : 0,
            object_extra_id: this.info.coupons[i].id ? this.info.coupons[i].id : 0,
          })
        }
      }
      // 第3步有可能返回第2步，不改动原参数info.coupons
      this.info.coupons_send = couponsList
      this.$emit('nextstep', 3, this.info.id, this.info)
    },
    // 中央活动库详情（新建模板活动）
    async getActivityStoreBossDetail () {
      try {
        const { response, result } = await this.GetActivityStoreBossDetailApi({
          id: this.template_id,
        })
        if (response.status === 200 && result.code === 0) {
          result.data.template_id = this.template_id
          result.data.goods_data = [] // 商品列表
          result.data.service_data = [] // 服务列表
          result.data.upkeep_card_data = [] // 养护卡列表
          result.data.group_mange_data = [] // 拼团列表
          result.data.time_limit_data = [] // 秒杀列表
          result.data.coupon_data = [] // 优惠券列表
          result.data.help_info = {
            duration: '', // 助力时长
            num: '', // 助力人数
            rule: '', // 助力规则
            limit: 0, // 参与助力限制 0 无限制, 1 新用户
            launch_num: 1, // 发起次数
            assist_num: 1, // 参与次数
            type: 1,
            coupon_ids: [], // 优惠券id
            coupon_items: [], // 优惠券
            helper_type: 0, // 助力者是否开启奖励. 1开启， 0不开启
            helper_coupons: [], // 助力者奖励券
            helper_coupon_ids: [], // 助力者奖励券的id集合
            help_total: '',
          }
          if (result.data.start_time && result.data.end_time) {
            result.data.time = `${this.changeDateTime(result.data.start_time).trim()} 至 ${this.changeDateTime(result.data.end_time).trim()}`
          } else {
            result.data.time = ''
          }
          result.data.register_type = '1,2'
          result.data.user_limit = 0
          let relation = []
          result.data.relations.forEach(item => {
            // 关联对象类型1、内容，2、报名，3、商品，4、服务，5、养护卡，6、拼团，7、秒杀，8、优惠券, 9、助力活动
            switch (item.object_type) {
              case 3:
                relation.push({
                  type: 3,
                  shop_product_id: item.object_panel_id,
                  name: item.object_name,
                  pic: item.object_pic,
                  mini_price: item.object_sell_price,
                  object_id: item.object_panel_id,
                  object_extra_id: item.object_boss_id,
                })
                break
              case 4:
                relation.push({
                  type: 4,
                  product_id: item.object_panel_id,
                  name: item.object_name,
                  pic: item.object_pic,
                  mini_price: item.object_sell_price,
                  object_id: item.object_panel_id,
                  object_extra_id: item.object_boss_id,
                })
                break
              case 5:
                relation.push({
                  type: 5,
                  id: item.object_panel_id,
                  image_url: item.object_pic,
                  name: item.object_name,
                  num: item.object_num,
                  price: item.object_sell_price,
                  origin_price: item.object_origin_price,
                  object_id: item.object_panel_id,
                  object_extra_id: item.object_boss_id,
                })
                break
            }
          })
          result.data.relation = relation
          result.data.relation.forEach(item => {
            switch (item.type) {
              case 3:
                result.data.goods_data.push(item)
                break
              case 4:
                result.data.service_data.push(item)
                break
              case 5:
                result.data.upkeep_card_data.push(item)
                break
              default:
                break
            }
          })
          this.info = result.data
          this.info.sign_up_switch = 0
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取中央活动库详情数据失败',
            content: `${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取中央活动库详情数据失败',
          content: `错误：${err}`,
        })
      }
    },

    // 活动详情（编辑活动）
    async getActivityStoreDetail () {
      try {
        const { response, result } = await this.GetActivityStoreDetailApi({
          activity_id: this.activity_id,
        })
        if (response.status === 200 && result.code === 0) {
          // 调活动详情（编辑）接口的时候，后端返回来的封面图字段是cover
          result.data.cover_img = result.data.cover
          result.data.goods_data = [] // 商品列表
          result.data.service_data = [] // 服务列表
          result.data.upkeep_card_data = [] // 养护卡列表
          result.data.group_mange_data = [] // 拼团列表
          result.data.time_limit_data = [] // 秒杀列表
          result.data.coupon_data = [] // 优惠券列表
          result.data.help_info = {
            duration: '', // 助力时长
            num: '', // 助力人数
            rule: '', // 助力规则
            limit: 0, // 参与助力限制 0 无限制, 1 新用户
            launch_num: 1, // 发起次数
            assist_num: 1, // 参与次数
            type: 1,
            coupon_ids: [], // 优惠券id
            coupon_items: [], // 优惠券
            helper_type: 0, // 助力者是否开启奖励. 1开启， 0不开启
            helper_coupons: [], // 助力者奖励券
            helper_coupon_ids: [], // 助力者奖励券的id集合
            help_total: '',
          }
          if (result.data.start_time && result.data.end_time) {
            result.data.time = `${this.changeDateTime(result.data.start_time).trim()} 至 ${this.changeDateTime(result.data.end_time).trim()}`
          } else {
            result.data.time = ''
          }
          // 处理门店列表回显
          let StoreListArr = result.data.store_list.trim().split(',')
          for (let i = 0; i < StoreListArr.length; i++) {
            for (let x = 0; x < result.data.store.length; x++) {
              if (StoreListArr[i] === result.data.store[x].store_id.toString()) {
                this.store_list.push(result.data.store[x])
              }
            }
          }
          // 处理用户限制按钮回显
          if (Number(result.data.user_limit) !== 0) {
            this.btn_limit = 1
          }
          // 处理报名方式回显
          this.register_type = []
          let registerListArr = result.data.register_type.split(',')
          for (let i = 0; i < registerListArr.length; i++) {
            this.register_type.push(registerListArr[i])
          }
          let relation = []
          result.data.relation.forEach(item => {
            // 关联对象类型1、内容，2、报名，3、商品，4、服务，5、养护卡，6、拼团，7、秒杀，8、优惠券, 9、助力活动
            switch (item.type) {
              case 3:
                relation.push({
                  type: 3,
                  shop_product_id: item.object_id,
                  name: item.item_name,
                  pic: item.item_pic,
                  mini_price: item.sell_price,
                  object_id: item.object_id,
                  object_extra_id: item.object_extra_id,
                })
                break
              case 4:
                relation.push({
                  type: 4,
                  product_id: item.object_id,
                  pic: item.item_pic,
                  name: item.item_name,
                  mini_price: item.sell_price,
                  object_id: item.object_id,
                  object_extra_id: item.object_extra_id,
                })
                break
              case 5:
                relation.push({
                  type: 5,
                  id: item.object_id,
                  image_url: item.item_pic,
                  name: item.item_name,
                  num: item.num,
                  price: item.sell_price,
                  origin_price: item.origin_price,
                  object_id: item.object_id,
                  object_extra_id: item.object_extra_id,
                })
                break
              case 6:
                relation.push({
                  type: 6,
                  id: item.item_id,
                  num: item.num,
                  product_name: item.item_name,
                  goods_price: item.group_price,
                  pic: item.item_pic,
                  mini_price: item.group_price,
                  origin_price: item.sell_price,
                  object_id: item.product_id,
                  object_extra_id: item.object_extra_id,
                })
                break
              case 7:
                relation.push({
                  type: 7,
                  id: item.item_id,
                  product: {
                    name: item.item_name,
                    seckill_sku_price: item.sell_price,
                    sku_price: item.sell_price,
                    inventory_total: item.inventory_total,
                    pic: item.item_pic,
                    mini_price: item.limit_price,
                    origin_price: item.sell_price,
                    object_id: item.product_id,
                    object_extra_id: item.object_extra_id,
                  },
                })
                break
              case 9:
                relation.push({
                  type: 9,
                  id: item.id,
                })
                let content = item.content
                result.data.help_info = {
                  duration: content.duration,
                  num: content.num,
                  rule: content.rule, // 助力规则
                  limit: content.assist_num ? 0 : 1, // 参与助力限制 0 无限制, 1 新用户
                  launch_num: content.launch_num, // 发起次数
                  type: 1,
                  assist_num: content.assist_num || 1, // 参与次数
                  coupon_items: content.coupon, // 优惠券id,
                  helper_coupons: content.assist_coupon, // 助力者优惠券
                  helper_type: content.assist_prize, // 是否开启助力者奖励
                  helper_coupon_ids: content.assist_coupon.map(a => a.coupon_id),
                  help_total: content.help_total,
                }
                result.data.help_info.coupon_ids = content.coupon.map(cell => {
                  return cell.coupon_id
                })
                // this.button_list[8].disabled = true
                break
              case 10:
                relation.push({
                  type: 10,
                })
                break
              default:
                break
            }
          })
          result.data.relation = relation
          result.data.relation.forEach(item => {
            switch (item.type) {
              case 3:
                result.data.goods_data.push(item)
                break
              case 4:
                result.data.service_data.push(item)
                break
              case 5:
                result.data.upkeep_card_data.push(item)
                break
              case 6:
                result.data.group_mange_data.push(item)
                break
              case 7:
                result.data.time_limit_data.push(item)
                break
              default:
                break
            }
          })
          this.info = result.data
          // 处理选择优惠券弹框回显
          const storeCoupons = []
          for (let i = 0; i < this.info.coupons.length; i++) {
            if (this.info.coupons[i].item_id) {
              storeCoupons.push({
                coupon_id: this.info.coupons[i].item_id,
                coupon_name: this.info.coupons[i].item_name,
                discount_amount: this.info.coupons[i].discount_amount,
                effective_days: this.info.coupons[i].effective_days,
                coupon_type_name: this.info.coupons[i].coupon_type_name,
                coupon_use_type_name: this.info.coupons[i].coupon_use_type_name,
                coupon_use_type: this.info.coupons[i].coupon_use_type,
                coupon_type: this.info.coupons[i].coupon_type,
                effective_type: this.info.coupons[i].effective_type,
                condition_value: this.info.coupons[i].condition_value,
              })
            }
          }
          this.store_coupons = storeCoupons
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取活动详情数据失败',
            content: `${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取活动详情数据失败',
          content: `错误：${err}`,
        })
      }
    },
  },
  watch: {
    // 该组件是否在页面上显示
    is_show () {
      if (this.is_show && this.is_edit) {
        // 调活动详情（编辑）
        if (!this.is_save_data) {
          // 重置初始参数
          this.info = {
            title: '', // 活动名称
            time: '', // 活动时间
            start_time: '', // 活动开始时间
            end_time: '', // 活动结束时间
            description: '', // 活动介绍
            content: '', // 活动内容
            content_imgs: [], // 活动内容图片
            cover_img: '', // 活动封面图
            poster_img: '', // 海报
            slider_img: '', // 轮播图
            coupons: [], // 优惠券
            store: [], // 门店信息
            sign_up_switch: 0,
            user_limit: 0, // 人群限制：0-无限制 1-小程序下单客户 2-小程序未下单客户
            register_type: '1,2', // 报名方式 1车牌 2车型 3公里数 多个用逗号分隔(例: 1,2)
          }
          this.store_coupons = []
          this.btn_limit = 0
          this.register_type = [1, 2]
          this.store_list = []
          this.getActivityStoreDetail()
        }
      } else if (this.is_show && !this.is_edit) {
        // 调模板详情（添加）
        if (!this.is_save_data) {
          // 重置初始参数
          this.info = {
            title: '', // 活动名称
            time: '', // 活动时间
            start_time: '', // 活动开始时间
            end_time: '', // 活动结束时间
            description: '', // 活动介绍
            content: '', // 活动内容
            content_imgs: [], // 活动内容图片
            cover_img: '', // 活动封面图
            poster_img: '', // 海报
            slider_img: '', // 轮播图
            coupons: [], // 优惠券
            store: [], // 门店信息
            sign_up_switch: 0,
            user_limit: 0, // 人群限制：0-无限制 1-小程序下单客户 2-小程序未下单客户
            register_type: '1,2', // 报名方式 1车牌 2车型 3公里数 多个用逗号分隔(例: 1,2)
          }
          this.store_coupons = []
          this.btn_limit = 0
          this.register_type = [1, 2]
          this.store_list = []
          this.getActivityStoreBossDetail()
        }
      }
    },
    // 用户限制按钮
    btn_limit () {
      if (this.btn_limit === 0) {
        this.info.user_limit = 0
      }
    },
    // 报名方式传参
    register_type () {
      let registerType = [...this.register_type]
      this.info.register_type = registerType.sort((a, b) => a - b).join(',')
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/modules/creation-modal'
.field-group
  border-bottom 0
.form-wrapper .field.long
  min-width 900px
  font-size 12px
label
  position relative
.must:before
  content '*'
  color #f56c6c
  position absolute
  left -15px
  top 3px
  font-size 15px
.desc-box
  height 12px
  position relative
  font-size 12px
.desc-text
  color red
.textbox-count
  position absolute
  bottom 0
  right 0
  color #888
.upload-pic
  display inline-block
  margin-top 4px
  width 120px
  height 120px
  margin-right 8px
.upload-poster
  display inline-block
  margin-top 4px
  width 200px
  height 120px
  margin-right 8px
.font-des
  font-size 12px
  color red
  margin-bottom 5px
// 选择优惠券表格
.box
  width 750px
.coupon
  background-color #f0f1f2
  padding-left 8px
  .w-30
    width 30px
  .w-60
    width 60px
  .w-110
    width 110px
  .w-180
    width 180px
  .w-350
    width 350px
  li
    width 94px
    margin-right 20px
    line-height 36px
  li.operation
    width 50px
    text-align center
  li:last-child
    margin-right 0
.coupon-list
  padding-left 8px
  border-bottom 1px solid #eee
  cursor pointer
  border-left 2px solid transparent
  .w-30
    width 30px
  .w-60
    width 60px
  .w-110
    width 110px
  .w-180
    width 180px
  .w-350
    width 350px
  li
    width 94px
    margin-right 20px
    line-height 34px
    white-space nowrap
    text-overflow ellipsis
    height 34px
    overflow hidden
    color #666
  li.operation
    width 50px
    text-align center
  li:last-child
    margin-right 0
.coupon-list:hover
  border-left 2px solid #ffc723
  box-shadow 0 2px 8px 0 rgba(0, 0, 0, 0.08)
.clearfix:after
  content '.'
  display block
  height 0
  clear both
  visibility hidden
.fl
  float left
.type-item
  display inline-flex
  min-width 88px
.checkbox
  margin-right 20px
.change-box
  margin-top 30px
  display flex
  justify-content space-between
  align-items center
  font-size 13px
.btn-people
  margin-top 60px
.not-allow
  cursor not-allowed
</style>


// WEBPACK FOOTER //
// src/components/content/modal/ContentTemplateTwo.vue